import React from 'react';

/**
 * @param {string} buttonText 
 */
const DropdownButton = ({ buttonText }) => (
    <div className="header-dropdown help-dropdown has-submenu">
        <span>{buttonText}</span>
        &nbsp;
        <span className="glyphicon glyphicon-triangle-bottom" aria-hidden="true" />
    </div>
);

export default DropdownButton;
